const WEEKDAY_FORMAT = new Intl.DateTimeFormat('es-AR', { weekday: 'long' });

export function parseDate(iso: string): Date {
  const [year, month, day] = iso.split('-').map(Number);
  return new Date(year, month - 1, day);
}

// "2026-07-24" -> "24/07/26"
export function formatShortDate(iso: string): string {
  const [year, month, day] = iso.split('-');
  return `${day}/${month}/${year.slice(2)}`;
}

export function weekdayName(iso: string): string {
  const name = WEEKDAY_FORMAT.format(parseDate(iso));
  return name.charAt(0).toUpperCase() + name.slice(1);
}

// "2026-07-23T18:05:00-03:00" -> "23/07 · 18:05"
export function formatTimestamp(iso: string): string {
  const date = new Date(iso);
  const pad = (value: number) => String(value).padStart(2, '0');
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)} · ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function formatDuration(minutes: number): string {
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;

  if (!hours && !rest) return '0 h';
  if (!hours) return `${rest} m`;
  if (!rest) return `${hours} h`;
  return `${hours} h ${String(rest).padStart(2, '0')} m`;
}
